export default __webpack_public_path__ + "static/media/stuck-veskovic-poolbau-1.08aca1a6.jpg";